if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            this.updateCartIconBubble(response);
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      updateCartIconBubble(parsedState) {
        const targetElement = document.getElementById('cart-icon-bubble');
        if (!targetElement) return;

        const renderBubbleFromCartJson = (cartJson) => {
          const count = Number(cartJson?.item_count);
          if (Number.isNaN(count)) return false;

          let bubble = targetElement.querySelector('.cart-count-bubble');
          if (count <= 0) {
            if (bubble) bubble.remove();
            return true;
          }

          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            targetElement.appendChild(bubble);
          }

          const visibleCount = bubble.querySelector('[aria-hidden="true"]');
          const accessibleCount = bubble.querySelector('.visually-hidden');
          if (visibleCount) visibleCount.textContent = count < 100 ? String(count) : '';
          if (accessibleCount) accessibleCount.textContent = `${count} item${count === 1 ? '' : 's'} in cart`;
          return true;
        };

        const renderBubble = (htmlString) => {
          if (!htmlString) return false;

          const html = new DOMParser().parseFromString(htmlString, 'text/html');
          const sourceElement = html.querySelector('#shopify-section-cart-icon-bubble') || html.querySelector('a');

          if (!sourceElement) return false;

          targetElement.innerHTML = sourceElement.innerHTML;
          return true;
        };

        if (renderBubble(parsedState?.sections?.['cart-icon-bubble'])) return;
        if (renderBubbleFromCartJson(parsedState)) return;

        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`, { credentials: 'same-origin', cache: 'no-store' })
          .then((response) => response.text())
          .then((htmlString) => {
            if (renderBubble(htmlString)) return null;
            return fetch(`${routes.cart_url}.js?inkybox_ts=${Date.now()}`, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
              cache: 'no-store',
            })
              .then((response) => response.json())
              .then(renderBubbleFromCartJson);
          })
          .catch((error) => console.error(error));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
